import * as React from 'react';

function SvgStatement(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15.357h8a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5H6a.5.5 0 00-.5.5v11a.5.5 0 00.5.5zm8 1.5H6a2 2 0 01-2-2v-11a2 2 0 012-2h8a2 2 0 012 2v11a2 2 0 01-2 2z"
        fill={props.color}
      />
      <path
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        d="M7.75 6.25h4.5M7.75 9.25h4.5"
      />
    </svg>
  );
}

export default SvgStatement;
